import { Outlet, useLocation } from 'react-router';
import { findHubForPath } from '@/navigation/registry';
import { DensePagePanel, DensePageShell } from './DensePageShell';
import { SubjectHubPage } from './SubjectHubPage';
import { FinanceWorkspaceShell } from '@/features/finance/FinanceWorkspaceShell';
import { EstimatingWorkspaceShell } from '@/features/estimating/EstimatingWorkspaceShell';

/**
 * Default page chrome for every module route:
 * - Subject hubs get the shared tab shell.
 * - Every other page fills the viewport; overflow scrolls inside one panel.
 */
export function HubAwareOutlet() {
  const location = useLocation();
  const hub = findHubForPath(location.pathname);

  if (hub?.id === 'estimations-bids') {
    return <EstimatingWorkspaceShell><Outlet /></EstimatingWorkspaceShell>;
  }

  if (hub?.id === 'financials') {
    return <FinanceWorkspaceShell><Outlet /></FinanceWorkspaceShell>;
  }

  if (hub && !hub.ownsNestedLayout) {
    return (
      <SubjectHubPage hub={hub}>
        <Outlet />
      </SubjectHubPage>
    );
  }

  if (hub?.ownsNestedLayout) {
    return <Outlet />;
  }

  return (
    <DensePageShell>
      <DensePagePanel>
        <Outlet />
      </DensePagePanel>
    </DensePageShell>
  );
}
